"use strict";

exports.__esModule = true;
exports.logical = logical;

var _utils = require("@chakra-ui/utils");

var _directionality = _interopRequireDefault(require("./directionality"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Polyfill for border-{start|end}-radius properties.
 * We'll remove this once css logical properties is supported in major browsers
 */
function logicalTransform(opts) {
  var transform = opts.transform,
      ltr = opts.ltr,
      rtl = opts.rtl;

  var rtlTransform = function rtlTransform(value, scale, props) {
    var _directional = (0, _directionality["default"])(props),
        getLogicalStyle = _directional.getLogicalStyle;

    var raw = (0, _utils.getWithDefault)(value, scale);
    return getLogicalStyle({
      rtl: rtl,
      ltr: ltr,
      value: raw
    });
  };

  return transform ? (0, _utils.compose)(transform, rtlTransform) : rtlTransform;
}

function logical(opts) {
  var property = opts.property,
      scale = opts.scale,
      transform = opts.transform;
  return {
    property: "&",
    scale: scale,
    transform: logicalTransform(_extends({}, property, {
      transform: transform
    }))
  };
}
//# sourceMappingURL=logical-prop.js.map